export enum Mode {
  Default = 'default',
  LinkToChannel = 'linkToChannel',
  LinkToPet = 'linkToPet',
}

export enum DetailViewTabName {
  Upcoming = 'Upcoming',
  History = 'History',
  Active = 'Active',
  None = 'None',
}

export enum ShowDetailView {
  Appointments = 'Appointments',
  ServicesDue = 'Services Due',
  None = 'None',
}
